import { __assign, __read, __rest } from "tslib";
import classNames from "classnames";
import React, { useState } from "react";
import { useDefaultValue } from "../form/controlled";
import { Icon } from "../icon";
import { callBoth, useConfig } from "../util";
import { injectValue } from "../_util/inject-value";
import { KeyMap } from "../_util/key-map";
var defaultCharacter = function (size) { return [
    React.createElement(Icon, { type: "star", className: size === "l" ? "size-l" : "" }),
    React.createElement(Icon, { type: "star-warning", className: size === "l" ? "size-l" : "" }),
]; };
var primaryCharacter = function (size) { return [
    React.createElement(Icon, { type: "star", className: size === "l" ? "size-l" : "" }),
    React.createElement(Icon, { type: "star-primary", className: size === "l" ? "size-l" : "" }),
]; };
export var Rate = React.forwardRef(function Rate(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var _a = useDefaultValue(props, 0), value = _a.value, onChange = _a.onChange, _b = _a.count, count = _b === void 0 ? 5 : _b, _c = _a.allowClear, allowClear = _c === void 0 ? true : _c, allowHalf = _a.allowHalf, readonly = _a.readonly, theme = _a.theme, size = _a.size, _d = _a.character, character = _d === void 0 ? theme === "primary"
        ? primaryCharacter(size)
        : defaultCharacter(size) : _d, className = _a.className, restProps = __rest(_a, ["value", "onChange", "count", "allowClear", "allowHalf", "readonly", "theme", "size", "character", "className"]);
    // 内部
    var innerValue = Math.round(value * 2);
    var _e = __read(useState(-1), 2), hoverValue = _e[0], setHoverValue = _e[1];
    var current = hoverValue >= 0 ? hoverValue : innerValue;
    function handleClick(event, value) {
        if (readonly) {
            return;
        }
        setHoverValue(value);
        if (allowClear && innerValue === value) {
            onChange(0, { event: event });
            setHoverValue(-1);
            return;
        }
        onChange(Number((value / 2).toFixed(1)), {
            event: event,
        });
    }
    function handleMouseEnter(value) {
        if (readonly) {
            return;
        }
        setHoverValue(value);
    }
    function handleMouseLeave() {
        setHoverValue(-1);
    }
    function handleKeyDown(event) {
        if (readonly) {
            return;
        }
        switch (event.key) {
            case KeyMap.Left:
                setHoverValue(-1);
                if (innerValue >= 1) {
                    onChange(Number(((innerValue - (allowHalf ? 1 : 2)) / 2).toFixed(1)), { event: event });
                }
                break;
            case KeyMap.Right:
                setHoverValue(-1);
                if (innerValue < count * 2) {
                    onChange(Number(((innerValue + (allowHalf ? 1 : 2)) / 2).toFixed(1)), { event: event });
                }
                break;
            case KeyMap.Backspace:
                setHoverValue(-1);
                onChange(0, { event: event });
                break;
        }
    }
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-rate", className) }, restProps, { tabIndex: 0, role: "radiogroup", onMouseLeave: callBoth(restProps.onMouseLeave, handleMouseLeave), onKeyDown: callBoth(restProps.onKeyDown, handleKeyDown) }), Array(count)
        .fill(null)
        .map(function (_, index) {
        var itemValue = index * 2 + 2;
        var half = itemValue === current + 1 && current % 2 > 0;
        var full = itemValue <= current;
        var _a = __read(injectValue(character)({
            index: index,
            half: half,
            full: full,
        }), 2), inactive = _a[0], active = _a[1];
        return (React.createElement("div", { className: classNames(classPrefix + "-rate__item"), key: index },
            allowHalf && (React.createElement("div", { className: classPrefix + "-rate__item-up", onClick: function (event) { return handleClick(event, itemValue - 1); }, onMouseEnter: function () { return handleMouseEnter(itemValue - 1); } }, !(full || half) ? inactive : active)),
            React.createElement("div", { className: classPrefix + "-rate__item-down", onClick: function (event) { return handleClick(event, itemValue); }, onMouseEnter: function () { return handleMouseEnter(itemValue); } }, !full ? inactive : active)));
    })));
});
//# sourceMappingURL=Rate.js.map